import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { styles } from '../org-serviceline/org-servicelines.styles';
import { PopoverBody, Stack, Box, Flex, Text, PopoverContent, Portal, Divider } from '@chakra-ui/react';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
import { DashboardSelectionSubNav } from './dashboard-selection-subnav';
import history from '../../history';
import { AmplifyCore } from '@codametrix/ui-common';
export const DashboardSelection = ({ dashboardSelectionOpened, activeDashboard, resources, handleDashboardSelection, dashboardPaths, activeContext, ...props })=>{
    const classes = styles();
    const tableauDashboardResourceId = resources.find((resource)=>resource.resourceName === 'tableau_dashboard')?.resourceId;
    const sections = resources.filter(// Config exists
    (resource)=>resource.parentId === tableauDashboardResourceId && // Config is enabled for active service line
        AmplifyCore.benchEditable.verifyServiceLine(resource, activeContext?.serviceLineName ?? ''));
    let dashboardOptions = {};
    if (sections) {
        sections.forEach((section)=>{
            const dashboardResources = resources.filter((resource)=>resource.parentId === section.resourceId && Object.keys(dashboardPaths).includes(resource.resourceName));
            dashboardOptions[section.resourceName] = {
                name: JSON.parse(section.metadata).label,
                dashboards: dashboardResources.map((resource)=>({
                        dashboardName: resource.label,
                        dashboardResource: resource.resourceName
                    }))
            };
        });
    }
    const defaultDashboard = Object.values(dashboardOptions)[0].dashboards[0];
    useEffect(()=>{
        if (!activeDashboard) {
            handleDashboardSelection(defaultDashboard?.dashboardName, defaultDashboard?.dashboardResource);
        }
    }, [
        activeDashboard,
        defaultDashboard,
        handleDashboardSelection
    ]);
    let [activeDashboardName, setActiveDashboardName] = useState(activeDashboard?.length ? activeDashboard : defaultDashboard?.dashboardName.split(' ')[0].toLowerCase());
    let [activeDashboardSection, setActiveDashboardSection] = useState(sections[0]);
    useEffect(()=>{
        if (activeDashboard?.length > 0) {
            setActiveDashboardName(activeDashboard);
        }
    }, [
        activeDashboard
    ]);
    const handleSectionSelection = (section)=>{
        setActiveDashboardSection(section);
        setActiveDashboardName(dashboardOptions[section.resourceName].dashboards[0].dashboardName.split(' ')[0].toLowerCase());
    };
    const handleLocationSelection = (dashboardName, dashboardResource)=>{
        handleDashboardSelection(dashboardName, dashboardResource);
        history.push('/cmx/tableau/');
    };
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsx(Flex, {
            className: "dashboardSelection",
            "data-testid": "dashboardSelection",
            children: /*#__PURE__*/ _jsx(PopoverContent, {
                sx: classes['.mainGrid'],
                className: "popOverStyle",
                children: /*#__PURE__*/ _jsx(PopoverBody, {
                    sx: classes['.bodyGrid'],
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        children: [
                            sections.length > 1 ? /*#__PURE__*/ _jsx(Box, {
                                sx: classes['.popoverInsightsBox'],
                                children: dashboardSelectionOpened && sections.map((section)=>{
                                    const dashboardSubsection = dashboardOptions[section.resourceName];
                                    const { name } = dashboardSubsection;
                                    return /*#__PURE__*/ _jsx(Flex, {
                                        sx: classes['.popoverHeader'],
                                        flexDirection: "column",
                                        children: /*#__PURE__*/ _jsxs(Flex, {
                                            sx: classes['.switchItem'],
                                            className: `hoverCursor ${activeDashboardSection.resourceName === section.resourceName ? 'selectedItem' : ''}`,
                                            onClick: ()=>handleSectionSelection(section),
                                            children: [
                                                /*#__PURE__*/ _jsx(Text, {
                                                    children: name
                                                }),
                                                /*#__PURE__*/ _jsx(Flex, {
                                                    sx: classes['.switchArrow'],
                                                    children: /*#__PURE__*/ _jsx(Flex, {
                                                        sx: classes['.iconBox'],
                                                        children: /*#__PURE__*/ _jsx(BiomeIcon, {
                                                            iconName: IconName.Chevron_Right,
                                                            iconSize: "16"
                                                        })
                                                    })
                                                })
                                            ]
                                        }, name)
                                    }, name + 'header');
                                })
                            }) : dashboardSelectionOpened && /*#__PURE__*/ _jsx(DashboardSelectionSubNav, {
                                activeDashboardOptions: dashboardOptions[activeDashboardSection.resourceName],
                                activeDashboardName: activeDashboardName,
                                handleDashboardSelection: handleLocationSelection
                            }),
                            sections.length > 1 ? /*#__PURE__*/ _jsxs(Flex, {
                                sx: classes['.subnavContainer'],
                                children: [
                                    /*#__PURE__*/ _jsx(Divider, {
                                        orientation: "vertical",
                                        sx: classes['.subnavDivider']
                                    }),
                                    /*#__PURE__*/ _jsx(DashboardSelectionSubNav, {
                                        activeDashboardOptions: dashboardOptions[activeDashboardSection.resourceName],
                                        activeDashboardName: activeDashboardName,
                                        handleDashboardSelection: handleLocationSelection
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            })
        })
    });
};
